import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import EditIconImg from '../images/EditIcon.png'
import { Box, Button, IconButton, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useAuth } from '../hooks/useAuth'
import { ModalDelDialog } from './ModalDelDialog'
import { ConversionModalEditDialog } from './ConversionModalEditDialog'

type ConversionItemButtonProps = {
  title: string
  id: string
  pre_text: string
  post_text: string
  onDel: (id: string) => void
  onUpdate: (oldPreText: string, newPreText: string, newPostText: string) => void
}

export const ConversionItemButton: React.FC<ConversionItemButtonProps> = ({
  title, pre_text, post_text, id, onDel, onUpdate
}) => {
  const auth = useAuth()
  const [openDel, setOpenDel] = useState(false)
  const [openEdit, setOpenEdit] = useState(false)
  const [isFocused, setIsFocused] = useState(false)
  const [isHovered, setIsHovered] = useState(false)

  const handleCloseDel = () => { setOpenDel(false); setIsFocused(false) }
  const handleDel = () => { onDel(id); handleCloseDel() }

  const handleCloseEdit = () => { setOpenEdit(false); setIsFocused(false) }
  const handleSaveEdit = (newPreText: string, newPostText: string) => {
    onUpdate(pre_text, newPreText, newPostText)
    handleCloseEdit()
  }

  const handleMouseEnter = () => setIsHovered(true)
  const handleMouseLeave = () => setIsHovered(false)

  useEffect(() => { setIsFocused(false) }, [])

  return (
    <>
      {openEdit && (
        <ConversionModalEditDialog
          open={openEdit}
          title={title}
          preText={pre_text}
          postText={post_text}
          onClose={handleCloseEdit}
          onSave={handleSaveEdit}
        />
      )}
      {openDel && (
        <ModalDelDialog
          open={openDel}
          title={title}
          id={id}
          text={pre_text}
          onClose={handleCloseDel}
          onDel={handleDel}
        />
      )}
      <Button
        component="div"
        disableRipple
        disableFocusRipple
        disableElevation
        tabIndex={-1}
        role={undefined}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        sx={{
          marginBottom: '24px',
          display: 'flex',
          justifyContent: 'space-between',
          // font: "normal normal normal 21px/32px Noto Sans JP",
          color: isHovered ? '#282828' : '#FFFFFF',
          backgroundColor: '#282828',
          '&:hover': { backgroundColor: 'rgba(241, 241, 241)', opacity: 0.8 },
          paddingTop: '6px',
          paddingLeft: '38px',
          textAlign: 'left',
          height: '80px',
          width: '550px',
          maxWidth: '550px',
          borderRadius: '40px',
          cursor: 'default',
        }}
      >
        <Tooltip title={pre_text + ' ⇒ ' + post_text} enterTouchDelay={0}>
          <Box sx={{ display: 'flex', overflow: 'hidden' }}>
            <Typography
              sx={{
                textTransform: 'none',
                font: 'normal normal normal 21px/32px Noto Sans JP',
                fontSize: '21px',
                lineHeight: '32px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: '230px',
              }}
            >
              {pre_text}
            </Typography>
            <Typography
              sx={{
                textTransform: 'none',
                font: 'normal normal normal 21px/32px Noto Sans JP',
                fontSize: '21px',
                lineHeight: '32px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: '250px',
              }}
            >
              &nbsp;⇒&nbsp;{post_text}
            </Typography>
          </Box>
        </Tooltip>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            width: 96,
            visibility: isHovered ? 'visible' : 'hidden',
          }}
        >
          <IconButton
            onClick={() => setOpenEdit(true)}
            disabled={auth.isDisable}
            aria-label="edit"
          >
            <img src={EditIconImg} width="25px" height="25px" alt="edit" />
          </IconButton>
          <IconButton
            onClick={() => setOpenDel(true)}
            disabled={auth.isDisable}
            sx={{
                  color: 'red',
                  '& .MuiSvgIcon-root': {
                    fontSize: '40px',
                  },
            }}
            aria-label="delete"
          >
            <HighlightOffIcon sx={{ fontSize: '40px' }} />
          </IconButton>
        </Box>
      </Button>
    </>
  )
}